<svelte:options customElement="hb-messages-topics-card" />

<script lang="ts">
  import type { Component } from "./types/webcomponent.type";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  let {
    id = "", // style = "",
    chats = [],
  }: Component = $props();
  //  let componentStyleToSet: string = "";

  $effect(() => {
    // if (style) {
    // }

    if (typeof chats === "string") {
      try {
        chats = JSON.parse(chats);
      } catch (err) {
        console.error("error parsing chat", err);
      }
    }
    chats.forEach((chat) => {
      if (!chat.localeTimeString)
        chat.localeTimeString = chat.time
          ? new Date(chat.time).getHours().toString().padStart(2, "0") +
            ":" +
            new Date(chat.time).getMinutes().toString().padStart(2, "0")
          : "";
    });
  });
  function setSelectedChat(chat: Component["chats"][0]) {
    chats.forEach((c) => {
      if (c.chat_id !== chat.chat_id) c._selected = false;
      else c._selected = true;
    });
    chats = [...chats];
    dispatch("select", chat);
  }
</script>

{#if chats}
  {#each chats as chat, chatIndex (`${String(chat.chat_id ?? "")}:${chatIndex}`)}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <article
      class="media hb-topics-item mb-0 py-2 px-2"
      class:hb-topics-item--selected={chat._selected}
      onclick={() => {
        setSelectedChat(chat);
      }}
    >
      <figure class="media-left my-0 ml-0">
        <p class="image is-64x64">
          <img class="is-rounded" src={chat.img_uri} alt="" />
        </p>
      </figure>
      <div class="media-content is-clipped">
        <div class="level is-mobile mb-2 is-align-items-flex-start">
          <div class="level-left mb-0">
            <div class="level-item is-narrow">
              <span class="has-text-weight-semibold is-size-6">{chat.title}</span>
            </div>
          </div>
          <div class="level-right mb-0">
            <div class="level-item">
              <span class="is-size-7 hb-topics-item__time">{chat.localeTimeString}</span>
            </div>
          </div>
        </div>
        <div class="level is-mobile mb-0">
          <div class="level-left mb-0">
            <div class="level-item">
              <p class="is-size-7 mb-0 has-text-weight-light hb-topics-item__preview">
                {chat.text}
              </p>
            </div>
          </div>
          <div class="level-right mb-0">
            <div class="level-item">
              <span class="tag is-light is-rounded"
                >{chat.counter ? chat.counter.toString() : "0"}</span
              >
            </div>
          </div>
        </div>
      </div>
    </article>
  {/each}
{/if}

<!-- svelte-ignore css_unused_selector (Bulma forwards many selectors; only a subset used in markup) -->
<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
